export const svgToDataURL = (svg: string) => (
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
);
